import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLanguage } from '../context/LanguageContext';
import Swal from 'sweetalert2';
import './styles/BookModal.css';
import dawnloadIcon from '../assets/g4.png';
import readIcon from '../assets/g5.png';
import byIcon from '../assets/g6.png';
import pagesIcon from '../assets/g7.png';
import categoryIcon from '../assets/g8.png';


export default function BookModal({ book, onClose }) {
    const { language, t } = useLanguage();
    const isRtl = language === 'ar';
    const dir = isRtl ? 'rtl' : 'ltr';
    const [closing, setClosing] = useState(false); 

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = 'unset'; };
    }, []);

    const handleClose = () => {
        setClosing(true);
        setTimeout(() => {
            onClose();
        }, 300); 
    };

    const handleRead = () => {
         setClosing(true);
    setTimeout(() => {
        onClose(); 
        setTimeout(() => {
              Swal.fire({
                    html: t("books.downloadModalText").replace(/\n/g, "<br/>"),
                    showConfirmButton: true,
                    confirmButtonText: t("books.downloadModalConfirm"),
                    icon: undefined,
                    backdrop: "rgba(255,255,255,0.18)",
                    zIndex: 20000,
                }).then((result) => {
                if (result.isConfirmed) {
                    window.open(book.downloadLink, '_blank');
                }
            });
        }, 50);
    }, 300);
    };

    const handleDownload = () => {
        // بدء أنيميشن الإغلاق
        setClosing(true);
        setTimeout(() => {
            onClose(); // إغلاق المودال
            // بعد إغلاق المودال مباشرة، نفتح SweetAlert مع تأخير بسيط لضمان اختفاء الخلفية
            setTimeout(() => {
                Swal.fire({
                    html: t("books.downloadModalText").replace(/\n/g, "<br/>"),
                    showConfirmButton: true,
                    confirmButtonText: t("books.downloadModalConfirm"),
                    icon: undefined,
                    backdrop: "rgba(255,255,255,0.18)",
                    zIndex: 20000,
                }).then((result) => {
                    if (result.isConfirmed) {
                        const link = document.createElement('a');
                        link.href = book.downloadLink;
                        link.download = '';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                });
            }, 50);
        }, 300); // انتظار انتهاء أنيميشن الإغلاق
    };


    return createPortal(
        <div className={`custom-modal-overlay ${closing ? 'closing' : ''}`} onClick={handleClose}>
            <div className={`custom-modal-container ${closing ? 'closing' : ''}`} dir={dir} onClick={(e) => e.stopPropagation()}>
                <button className="modal-close-btn" onClick={handleClose}>✕</button>
                <div className="custom-modal-content">
                    <div className="custom-modal-left">
                        <img src={book.coverSrc} alt={book.title} />
                    </div>
                    <div className="custom-modal-right">
                        <h3>{book.title}</h3>
                        <p className="short">{book.description}</p>
                        <p className="long-description">{book.longDescription}</p>
                        <div className="meta-info">
                            <span><img src={byIcon} alt='ByIcon' style={{width:"29px", height:"21px"}} /> {t("books.authorLabel")}: {book.author}</span>
                            <span><img src={pagesIcon} alt='pagesIcon' style={{width:"30px", height:"20px"}} /> {t("books.pagesLabel")}: {book.pages}</span>
                            <span><img src={categoryIcon} alt='categoryIcon' style={{width:"18px", height:"18px"}} />  {t("books.categoryLabel")}: {book.category}</span>
                        </div>
                      <div className="modal-buttons">

                           {language === 'en' && book.id === 1 && (
        <p style={{ 
            fontSize: '0.8rem', 
            color: '#888', 
            marginTop: '10px',
            width: '100%',
            marginBottom: '7px'
        }}>
            The English translation is currently in progress. 
            For now, you can enjoy the original Arabic version.
        </p>
    )}
    <button className="modal-btn read-btn modal-btns" onClick={handleRead} style={{background: "pink"}}>
        <img src={readIcon} alt="read icon" style={{width:"31px", height:"30px"}} /> {language === 'ar' 
            ? 'تفضل بالقراءة' 
            : (book.id === 1 ? 'Read in Arabic' : 'Enjoy reading')}
    </button>

    <button className="modal-btn download-btn-modal modal-btns" onClick={handleDownload}>
        <img src={dawnloadIcon} alt="dawnload icon" style={{width:"31px", height:"30px"}} /> {language === 'ar' 
            ? 'خُذه معك رفيقاً' 
            : (book.id === 1 ? 'Arabic Copy' : 'Carry it with you')}
    </button>

    
</div>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
}